export enum ClientPermission {
  ReadInvoice = 4071,
  PayInvoices = 4072,
  ReadJob = 4073,
  RequestJob = 4074,
  ViewPaymentHistory = 4075,
  ViewInvoiceTotals = 4076,
  ReadPreJobTicket = 4077,
  ReadPostJobTicket = 4078,
  ReadStatement = 4079,
  ReadQuote = 4080,
  ApproveQuote = 4081,
  ReadCreditMemo = 4082,
  ApproveCreditMemo = 4083,
  ReadDebitMemo = 4084,
  ApproveDebitMemo = 4085,
}

